import { render, staticRenderFns } from "./associat.vue?vue&type=template&id=1fcc371f&scoped=true"
import script from "./associat.vue?vue&type=script&lang=js"
export * from "./associat.vue?vue&type=script&lang=js"
import style0 from "./associat.vue?vue&type=style&index=0&id=1fcc371f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc371f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fcc371f')) {
      api.createRecord('1fcc371f', component.options)
    } else {
      api.reload('1fcc371f', component.options)
    }
    module.hot.accept("./associat.vue?vue&type=template&id=1fcc371f&scoped=true", function () {
      api.rerender('1fcc371f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/terminal/associat.vue"
export default component.exports